(() => {
  const focusableSelectors = 'button, [tabindex="0"]';

  document.addEventListener('click', e => {
    const openBtn = e.target.closest('[data-popup-id]');
    if (!openBtn) return;

    const popup = document.getElementById(openBtn.dataset.popupId);
    if (!popup) return;

    popup.classList.add('show');
    popup.focus();
  });

  document.addEventListener('click', e => {
    if (e.target.classList.contains('poc-close-btn') ||
        e.target.classList.contains('poc-popup-close-x') ||
        e.target.classList.contains('poc-popup')) {
      const popup = e.target.closest('.poc-popup');
      if (popup) popup.classList.remove('show');
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.poc-popup.show')
        .forEach(p => p.classList.remove('show'));
    }
  });
})();

